import ReportSelect from './ReportSelect';

export default ReportSelect;
